import { render, staticRenderFns } from "./sub-items.vue?vue&type=template&id=2df7065e&scoped=true&"
import script from "./sub-items.vue?vue&type=script&lang=js&"
export * from "./sub-items.vue?vue&type=script&lang=js&"
import style0 from "./sub-items.vue?vue&type=style&index=0&id=2df7065e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df7065e",
  null
  
)

export default component.exports